import React, { useCallback, useMemo } from 'react';
import SVGImage from '../components/layout/SVGImage';
import LoginSubmitButton from '../components/common/SubmitButton';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { statusCode } = location.state || {};

  const [title, message, icon] = useMemo(() => {
    switch (statusCode) {
      case '500':
        return [
          'server error',
          '죄송합니다, 알 수 없는 에러가 발생했습니다.',
          '😵',
        ];
      case '404':
        return [
          'page not found',
          '죄송합니다, 페이지를 찾을 수 없습니다.',
          '😢',
        ];
      default:
        return ['', '', ''];
    }
  }, []);

  const getStatusCodeColor = useMemo(() => {
    switch (statusCode) {
      case '404':
        return 'text-blue-light';
      default:
        return 'text-red-light';
    }
  }, []);

  const navigateHome = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    navigate('/forecast');
  }, []);

  return (
    <main>
      <div className="mt-[16vh] flex items-center justify-center">
        <SVGImage name="gridus-logo"></SVGImage>
        <SVGImage
          className="ml-[9px]"
          fill="#241F20"
          name="gridus-logo-text"
        ></SVGImage>
      </div>
      <div className="mt-[16vh] flex flex-col items-center justify-center">
        <p className="pop-40-bold leading-[40px] text-blue-light">{icon}</p>
        <p
          className={`pop-40-bold mt-[2vh] leading-[40px] ${getStatusCodeColor}`}
        >
          {statusCode}
        </p>
        <p className="pop-60-bold mt-[1vh] leading-[60px] text-dark-7">
          {title}
        </p>
        <p className="noto-normal-4 mt-[2vh] text-light-9">{message}</p>
      </div>
      <div className="mt-[8vh] flex justify-center">
        <form onSubmit={navigateHome}>
          <LoginSubmitButton text={t('error.goHome')} disabled={false} />
        </form>
      </div>
    </main>
  );
};
